import { LocalStorageUtil } from '@doda/common/src/utils/localStorageUtil';

/**
 * お知らせカウ予約訴求対象者の場合はtrue
 * @returns {boolean}
 */
export const isNotificationCounselingTarget = () => {
  const result = getOshiraseCounseling();
  return Boolean(result);
};

/**
 * カウンセリング予約判定結果をlocalStorageにセットする
 * @param counselingShow
 */
export const setOshiraseCounseling = (counselingShow: boolean) => {
  LocalStorageUtil.setItem('oshirase_counseling', counselingShow);
};

/**
 * カウンセリング予約判定結果をlocalStorageから取得する
 * @returns {boolean}
 */
const getOshiraseCounseling = () => {
  return LocalStorageUtil.getItem('oshirase_counseling');
};
